module.exports = __webpack_public_path__ + "static/media/facebook.545ced3b.svg";